<template>
  <div class="popwind">
    <img
      :src="require('@/assets/images/comp/弹窗-' + type + '.png')"
      class="bg"
      alt=""
      :style="{ width: type == '污染源' ? '5.2rem' : '2.5rem' }"
    />
    <img
      src="@/assets/images/comp/close.png"
      class="close"
      @click="vue_this.pointData = null"
      alt=""
    />
    <p class="popwind_title"><slot name="name"></slot></p>
    <p class="popwind_time"><slot name="time"></slot></p>
    <div class="popwind_cont">
      <slot name="cont"></slot>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  computed: {
    ...mapGetters([""])
  },
  props: ["vue_this", "type"],
  data() {
    return {};
  },
  watch: {},
  mounted() {},
  methods: {},
  destroyed() {}
};
</script>
<style lang="stylus" scoped>
.popwind
  position absolute
  top 50%
  left 50%
  transform: translate(-50%,-50%)
  z-index 5
  width max-content
  height max-content
  .close
    width .15rem
    position absolute
    top .02rem
    right .1rem
    z-index 1
    cursor pointer
  .popwind_title
    position absolute
    z-index 1
    top .15rem
    left .25rem
    color #0EC2FF
    font-size: .1rem
  .popwind_time
    position absolute
    z-index 1
    top .18rem
    color rgba(255,255,255,.65)
    font-size: .06rem
    right .1rem
  .popwind_cont
    position absolute
    z-index 1
    top .4rem
    left .15rem
    right .15rem
    bottom .1rem

// loadAni_left .5s linear forwards
</style>



// WEBPACK FOOTER //
// src/components/popwind.vue